<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'DateTimeRangePicker',
})
</script>
<template>
  <DatePicker.RangePicker
    :popupClassName="bem()"
    show-time
    :ranges="DATE_RANGE_PRESETS"
    value-format="YYYY-MM-DD HH:mm:ss"
    allow-clear
    v-bind="$attrs"
  />
</template>

<script lang="ts" setup name="DateTimeRangePicker">
import { DatePicker } from 'ant-design-vue'
import dayjs from 'dayjs'
const [_, bem] = createNamespace('DateTimeRangePicker')
import { createNamespace } from '@bd/vue3-utils'

const DATE_RANGE_PRESETS: any = {
  '5分钟': [dayjs().add(-5, 'm'), dayjs()],
  '15分钟': [dayjs().add(-15, 'm'), dayjs()],
  今天: [dayjs().startOf('day'), dayjs().endOf('day')],
  昨天: [dayjs().add(-1, 'd').startOf('day'), dayjs().add(-1, 'd').endOf('day')],
  本周: [dayjs().startOf('week'), dayjs().endOf('week')],
  上周: [dayjs().add(-1, 'w').startOf('week'), dayjs().add(-1, 'w').endOf('week')],
  本月: [dayjs().startOf('month'), dayjs().endOf('month')],
  上月: [dayjs().add(-1, 'M').startOf('month'), dayjs().add(-1, 'M').endOf('month')]
}
</script>
<style lang="less">
.ant-picker {
  width: 100%;

  &-dropdown-range {
    .ant-picker-preset {
      .ant-tag-blue {
        border-color: #e6f6ff;
        cursor: pointer;
      }
    }
  }
}
</style>
